import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Result } from '@app/models/common/result';
import { getItem, setItem, StorageItem } from '@core/utils';
import { environment } from '@environments/environment';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { finalize, map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SystemService {
  public sysFeatsSubject: BehaviorSubject<Record<string, string>>;
  public sysFeatsObservale: Observable<Record<string, string>>;
  private sysFeatsReq$?: Observable<Record<string, string>>;
  private lastFetchedAt = 0;
  private readonly cacheMs = 60000;

  constructor(private http: HttpClient) {
    const cachedSysFeats = <Record<string, string>>getItem(StorageItem.SysFeats) || {};
    this.sysFeatsSubject = new BehaviorSubject<Record<string, string>>(
      cachedSysFeats,
    );
    if (Object.keys(cachedSysFeats).length > 0) {
      this.lastFetchedAt = Date.now();
    }
    this.sysFeatsObservale = this.sysFeatsSubject.asObservable();
  }

  public get sysFeats(): Record<string, string> {
    return this.sysFeatsSubject.value;
  }

  getSysFeatures(forceRefresh = false): Observable<Record<string, string>> {
    const now = Date.now();
    const cachedData = this.sysFeats;
    const hasCache = Object.keys(cachedData || {}).length > 0;
    if (!forceRefresh && hasCache && now - this.lastFetchedAt < this.cacheMs) {
      return of(cachedData);
    }
    if (this.sysFeatsReq$) {
      return this.sysFeatsReq$;
    }

    const url = `${environment.apiUrl}/system/features`;
    this.sysFeatsReq$ = this.http.get<Result<Record<string, string>>>(url).pipe(
      map(res => {
        const data = res.data || {};
        setItem(StorageItem.SysFeats, data);
        this.sysFeatsSubject.next(data);
        this.lastFetchedAt = Date.now();
        return data;
      }),
      finalize(() => {
        this.sysFeatsReq$ = undefined;
      }),
      shareReplay(1),
    );
    return this.sysFeatsReq$;
  }
}
